/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    // ICommerceApiSettings,
    ICreateActionContext
} from '@msdyn365-commerce/core';

import { getPromiseDateAsync } from './DataService/DataActionExtension.g'; //getStockAvailDateAsync,
import { ICalculatePromiseDateResponse } from './DataService/DataServiceEntities.g';

/**
 * Getpromisedate Input Action
 */
export class GetpromisedateInput implements IActionInput {
    // Input properties
    public accountNum: number;
    public catalogId: number;
    public items: string[];
    public dispositionCode: string;
    public quantities: number[];

    constructor(accountNum: number | string, catalogId: number | string, items: string[], dispositionCode: string, quantities: number[]) {
        this.accountNum = typeof accountNum === 'string' ? +accountNum : accountNum;
        this.catalogId = typeof catalogId === 'string' ? +catalogId : catalogId;
        this.items = items;
        this.dispositionCode = dispositionCode;
        this.quantities = quantities;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetPromiseDateInput`;
    public getCacheObjectType = () => 'getPromiseDateInput';
    public dataCacheType = (): CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetpromisedateData {
    text: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (
    args: ICreateActionContext,
    accountNum: number | string,
    catalogId: number | string,
    items: string[],
    dispositionCode: string,
    quantities: number[]
): IActionInput => {
    return new GetpromisedateInput(accountNum, catalogId, items, dispositionCode, quantities);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getPromiseDate(input: GetpromisedateInput, ctx: IActionContext): Promise<ICalculatePromiseDateResponse> {
    const result = await getPromiseDateAsync(
        { callerContext: ctx },
        input.items,
        input.accountNum,
        input.catalogId,
        input.dispositionCode,
        input.quantities
    ).catch(error => {
        ctx.telemetry.exception(error);
        ctx.trace('[GetPromiseDate] Unable to load promise date');
        throw new Error('[GetPromiseDate] Unable to load promise date');
    });
    return result;
}

export default createObservableDataAction({
    action: <IAction<ICalculatePromiseDateResponse>>getPromiseDate,
    // TODO: Give your data action a getPromiseDate id
    id: 'getPromiseDate',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
